import { type UseQueryResult, useQuery } from 'react-query';
import { CompantTypeService } from '@wealthlane/api-services/wealthlane-identity-service';
import { BrokerService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetBrokerOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const brokerOptions = useQuery(
    ['getBrokerOptions'],
    async () => {
      return await handleRequest(BrokerService.getApiCustomerBrokerOptions());
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.companyId,
          };
        });
      },
    }
  );

  return brokerOptions;
};

export default useGetBrokerOptions;
